<script setup lang="ts">
import type { AiUsage } from '../types/ai';
withDefaults(defineProps<{ usage?: AiUsage | null; label?: string }>(), { label: 'Tokenverbrauch' });
</script>

<template>
  <div class="ai-token-usage" role="status">
    <span>{{ label }}</span>
    <strong>Input {{ usage ? usage.inputTokens.toLocaleString('de-DE') : '—' }}</strong>
    <strong>Output {{ usage ? usage.outputTokens.toLocaleString('de-DE') : '—' }}</strong>
    <strong>Gesamt {{ usage ? usage.totalTokens.toLocaleString('de-DE') : '—' }}</strong>
    <small v-if="!usage">Vom KI-Anbieter nicht gemeldet.</small>
  </div>
</template>

<style scoped>
.ai-token-usage { display:flex; align-items:center; gap:8px 14px; flex-wrap:wrap; margin:12px 0; padding:10px 12px; border:1px solid var(--ui-border); border-radius:8px; color:var(--ui-text-muted); background:var(--ui-surface-1); font-size:12px; }
.ai-token-usage strong { color:var(--ui-text-soft); font-size:12px; white-space:nowrap; }
.ai-token-usage small { flex-basis:100%; }
</style>
